import React, { Component } from 'react';
import { Modal, Empty, Select, Spin } from 'antd';
import Storage from '../../services/local-store';
import networkList from '../../constants/networkList';

const { Option } = Select
const {homepage} = networkList;

class Multiple_units_switch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            "active_unit": null
        }
    }

    componentDidMount() {
        var userData = Storage.get('user_data')?JSON.parse(Storage.get('user_data')):[];
        if(userData && userData['unitid']!==null ){
            this.setState({ "active_unit": userData ? userData['unitid'] : null })
        }
        else{
            let all_tokens = Storage.get("all_tokens") && JSON.parse(Storage.get("all_tokens"));
            Storage.store("token",all_tokens.length>0 ? all_tokens[0]['token']:null); 
            this.setState({ "active_unit": all_tokens.length>0 ? all_tokens[0]['unitid'] : null })
        }
        this.getMapped_UnitsOfUser()
    }

    getMapped_UnitsOfUser(date) {        
        let all_tokens = Storage.get("all_tokens");
        let all_tokens_details = all_tokens!=="undefined" ? JSON.parse(all_tokens):[];
        let newData = [];
        if ( all_tokens_details && all_tokens_details.length !== 0) {
            all_tokens_details.map((rdata, rKey) => {
                newData.push({
                    'id': rdata['unitid'],
                    'name': rdata['unit_name'],
                    displayname: rdata['display_name'],
                })
            })
        }
        this.setState((state) => ({ 'mappedUnits': newData }));
    }

    unit_change = (e) => {
        let all_tokens = Storage.get("all_tokens") && JSON.parse(Storage.get('all_tokens'));
        let all_user_data = Storage.get("all_user_data") && JSON.parse(Storage.get('all_user_data'));
        let current_user= null
        all_tokens && all_tokens.map((data, key) => {
            if (data['unitid'] == e) {
                current_user = all_user_data ? all_user_data.find(o => o.unitid == e) : null;
                Storage.store("user_data", current_user);
                Storage.store("current_Unit", data);
                Storage.store("token", data['token']);
                Storage.store("display_name", data['display_name']);
            }
        })
        this.setState({ "active_unit": e }) 
        
        Modal.info({
            title: 'Processing',
            content: 'Please wait. Your request is being processed. Do not refresh or close your browser',
        })        
        setTimeout(() => { this.gotoDasahboard(current_user); window.location.reload() }, 1000)
    }

    gotoDasahboard(current_user) {                
        // let user_data = JSON.parse(Storage.get("user_data"))
        let role_id = current_user && current_user["roleid"]
        // Super admin, admin
        role_id && (role_id === "RL_ijmN" || role_id === "RL_uxwJ") &&
            this.props.history.push(`/dashboard`)
        // Technician
        role_id && (role_id === "RL_qjrf") &&
            this.props.history.push(`/queue/technician-view`)
        // Operator
        role_id && (role_id === "RL_dNpj") &&
            this.props.history.push(`/queue/operator-view`)
        // Doctor
        role_id && (role_id === "RL_fGhl") &&
            this.props.history.push(`/queue/doctor-view`)
        // Vitals
        role_id && (role_id === "RL_L4fj") &&
            this.props.history.push(`/queue/vitals-view`)
        // Biller
        role_id && (role_id === "RL_Rco9") &&
            this.props.history.push(`/queue/biller-view`)
        // Token Generator
        role_id && (role_id === "RL_J88m") &&
            this.props.history.push(`/queue/token-generator`)
    }    

    render() {
        let { mappedUnits, fetching, active_unit } = this.state;
        const setHref = str => (window.location.href = str);
        const currenthref = window.location.pathname;
        if(mappedUnits && mappedUnits.length>0 && mappedUnits[0]['name']!==undefined && currenthref!==`${homepage}/nurse-display` && currenthref!==`${homepage}/new-nurse-display` && currenthref!==`${homepage}/tv-display` && currenthref!==`${homepage}/nurse-stations` && currenthref!==`${homepage}/digital-signature`){

            return (
                <React.Fragment>
                {/* <b className='my-auto mr-1'>Unit </b> */}
                <Select
                    showSearch
                    placeholder="Select a Unit"
                    optionFilterProp="children"
                    placement='bottomRight'
                    defaultValue={active_unit ? active_unit : null}
                    value={active_unit ? active_unit : null}                
                    onChange={(e) => { this.unit_change(e) }}
                    notFoundContent={fetching ? <Spin size="small" /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                    style={{ width: '100%' }}
                    className="multiple-unit"
                >
                    {mappedUnits && mappedUnits.map((data, key) => {
                        return <Option key={key} value={data['id']}>{data['displayname']}</Option>
                    })}
                </Select>
            </React.Fragment>
        );
        }else{
            return null;
        }
       
    }
}

export default Multiple_units_switch;